<template>
    <group-backend-layout page-title="Organization Settings">
        <template #page_header>
            <div class="mb-8 flex justify-between border-b pb-4">
                <h1 class="text-[28px] font-semibold">Organization Settings</h1>
                <div class="hidden gap-4 lg:flex" v-if="form.isDirty">
                    <div class="btn btn-outline" @click="reset">
                        Discard Changes
                    </div>
                    <div class="btn btn-primary" @click="save">
                        Save Changes
                    </div>
                </div>
            </div>
        </template>

        <div class="mb-24 flex w-full flex-col gap-8 lg:flex-row">
            <div class="">
                <div
                    v-if="group.avatar"
                    class="group relative h-[160px] w-[160px] rounded border border-gray-400 bg-gray-250 bg-cover bg-center bg-no-repeat"
                    :style="'background-image: url(' + group.avatar + ')'"
                >
                    <div
                        class="invisible absolute bottom-0 flex w-full group-hover:visible"
                    >
                        <span
                            class="flex-grow rounded-b bg-black/75 px-2 py-1 text-center text-[14px] font-medium text-white hover:cursor-pointer hover:bg-white hover:text-black"
                            @click="editAvatar()"
                            title="Edit / Remove"
                        >
                            Edit / Remove
                        </span>
                    </div>
                </div>

                <drag-image-upload-field
                    v-else
                    v-model="form.groupAvatar"
                    image-preview-css="h-[160px] w-[160px] border border-gray-400 bg-gray-250"
                >
                    <div class="text-center">
                        <div class="">Upload a group logo</div>
                        <div class="text-[12px] font-medium">(jpg or png)</div>
                    </div>
                </drag-image-upload-field>
            </div>
            <div class="flex-grow">
                <form-input
                    label="Organization Name"
                    name="groupName"
                    v-model="form.groupName"
                ></form-input>
            </div>
        </div>
        <div
            v-if="form.isDirty"
            class="shadow-top fixed bottom-0 -ml-4 flex w-full justify-end gap-4 border-t border-t-gray-250 bg-white p-4 lg:hidden"
        >
            <div class="btn btn-outline" @click="reset">Discard Changes</div>
            <div class="btn btn-primary" @click="save">Save Changes</div>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import DragImageUploadField from "@/Components/DragImageUploadField";
import FormInput from "@/Components/FormInput";

export default {
    name: "GroupSettings",
    components: { FormInput, DragImageUploadField, GroupBackendLayout },
    props: {
        group: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                groupAvatar: this.group.avatar,
                groupName: this.group.name,
            }),
            forceShowAvatarUpload: false,
        };
    },
    methods: {
        save() {
            this.$inertia.post("/group/settings", this.form, {
                preserveState: false,
            });
        },
        reset() {
            this.$inertia.visit(route(route().current()));
        },
        editAvatar() {
            this.group.avatar = null;
            this.form.groupAvatar = null;
        },
    },
};
</script>
